import { render } from "./TutorialWelcome.vue?vue&type=template&id=1011ac9d&scoped=true"
import script from "./TutorialWelcome.vue?vue&type=script&lang=js"
export * from "./TutorialWelcome.vue?vue&type=script&lang=js"

import "./TutorialWelcome.vue?vue&type=style&index=0&id=1011ac9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1011ac9d"]])

export default __exports__